// temporary UiService used as standard module
// until UiService is fully converted

import _ from 'lodash';
import $ from 'jquery';
import { EVENTS, PRODUCT_TYPES } from './constants';
import EventBus from '../services/event-bus';
import UrlService from './url-service';
import DataStore from './data-store';
import ShopService from '../services/shop-service';
import { TreeItem } from '../../types';

let isCartOpen;
let isSidebarOpen;
let activeItem;
let openSideMenu;
let treeItems: TreeItem[];

export default {
    getTopOfView,
    scrollIntoView,
    toggleCart,
    toggleSidebar,
    isActive,
    get isCartOpen() {
        return isCartOpen;
    },
    get isSidebarOpen() {
        return isSidebarOpen;
    },
    getActiveItem() {
        return activeItem;
    },
    get openSideMenu() {
        return openSideMenu;
    },
    setActiveItem,
}
let debouncedUpdate = _.debounce(updateActiveItem, 50);
function init() {
    EventBus.$on(EVENTS.shopChanged,(shop) => treeItems = flattenTree(shop.productTree))
    initSidebarOpen();
    initCartOpen();
    listenToItemHref();
    $(window).on('scroll',()=>debouncedUpdate());
}

init();

function setActiveItem(item: TreeItem, scrollTo = true, animate = true) {
    if (activeItem != item) {
        activeItem = item;
        EventBus.$emit(EVENTS.activeItem, activeItem);
    }
    if (scrollTo) {
        scrollIntoView(item, animate);
    }
}
function flattenTree(treeItem: TreeItem): TreeItem[] {
    let arr = [treeItem];
    for (let child of treeItem.childs) {
        if (child.product.ty == PRODUCT_TYPES.Category) {
            arr = arr.concat(flattenTree(child));
        }
    }
    return arr;
}

function listenToItemHref() {
    // should hijack navigation instead, to intercept calls to $state.go() ?
    $('body').on('click','a',(event) => {
        if (event.currentTarget.href.includes('carte')){
            let hash = event.currentTarget.hash;
            let el = $(hash);
            if (el.length) {
                event.preventDefault();
                let item = getItem(el[0]);
                setActiveItem(item);
            }
        }
    });
}

function initCartOpen() {
    isCartOpen = $('body').hasClass('cartOpen')
    $('#menuOverlay').on('click', e => toggleCart(false));
    $('#closeCart').on('click', e => toggleCart(false));
    // $rootScope.$on('$stateChangeSuccess',_ => toggleCart(false))
    EventBus.$on(EVENTS.route.after,_ => toggleCart(false));
}

function toggleCart(open = !isCartOpen) {
    if (UrlService.includes('admin') || UrlService.includes('admin1')) {
        open = false;
    }
    if (open && isSidebarOpen) {
        toggleSidebar(false);
    }
    if (isCartOpen == open) {
        return;
    }
    isCartOpen = open;

    let myactiveItem = activeItem;
    if (isCartOpen) {
        $("#wrapper").removeClass("cartClosed");
        $("#wrapper").addClass("menuClosed");
        $("body").addClass("cartOpen");
        $("body").removeClass("menuOpen");
        $('#menuOverlay').fadeIn("fast");//,() => scrollIntoView(myactiveItem, false));
    } else {
        $("#wrapper").addClass("cartClosed");
        $("body").removeClass("cartOpen");
        $('#menuOverlay').fadeOut("fast");//,() => scrollIntoView(myactiveItem, false));
    }
    scrollIntoView(myactiveItem, false);
}


function updateActiveItem() {
    if (!treeItems) return;
    for(let i = treeItems.length - 1; i >= 0; i--) {
        if (isActive(treeItems[i])) {
            setActiveItem(treeItems[i], false);
            return;
        }
    }
}

function getItemEl(item) {
    if (!item) {
        return null;
    }
    let el = $('#'+ UrlService.dashifyItem(item));
    return el.length && el;
}

function getItem(el: Element) {
    let id = el.id;
    let tid = id.split('-')[0];
    return treeItems.find(item => item.tid == +tid);
}

function isActive(item) {
    let el = getItemEl(item);
    if (!el) {
        return false;
    }
    let scrollTop = $(window).scrollTop();
    let top = el.offset().top  - scrollTop;
    let bottom = top + el.outerHeight();

    let topOfView = getTopOfView();
    let bottomOfView = $('.mobile-footer nav').innerHeight();
    let middle = (window.innerHeight - topOfView - bottomOfView) / 2;
    return top <= middle && bottom > middle;
}

function getTopOfView() {
    // let navbarRect = window['navbar-main'].getBoundingClientRect();
    // let catNavbarRect = window['cat-navbar'].getBoundingClientRect();
    // let topOfView = Math.max(0,navbarRect.bottom) + catNavbarRect.height;

    let stickyHeader = document.getElementById('cat-navbar');
    let topmostVisiblePixel = stickyHeader && stickyHeader.getBoundingClientRect().bottom;
    return topmostVisiblePixel || 0;
}

function scrollIntoView(item: TreeItem, animate = false): boolean {
    let selector = '#' + UrlService.dashifyItem(item);
    let el = $(selector);
    if (el.length) {
        if (!animate) {
            window.scrollTo(0, el.offset()?.top - getTopOfView());
        } else {
            $('html').animate({scrollTop: el.offset().top - getTopOfView()}, 1000, 'swing', () => {
                // window.location.hash = selector;
                history.pushState({},'',location.pathname + selector);
            });
        }
        return true;
    } else {
        return false;
    }
}

function toggleSidebar(show: boolean = undefined) {
    if (UrlService.includes('admin') || UrlService.includes('admin1')) {
        toggleBackOfficeSidebar(show);
        toggleFrontOfficeSidebar(false);
    } else {
        toggleBackOfficeSidebar(false);
        toggleFrontOfficeSidebar(show);
    }
    EventBus.$emit(EVENTS.appResize);
}

function toggleFrontOfficeSidebar(show = !isSidebarOpen) {
    if (show && !ShopService.shop && !ShopService.qShop) {
        show = false;
    }
    if (show && isCartOpen) {
        toggleCart(false);
    }
    if (isSidebarOpen == show) {
        return;
    }
    isSidebarOpen = show;
    let myactiveItem = activeItem;
    if (isSidebarOpen) {
        $("#wrapper").removeClass("menuClosed");
        $("#wrapper").addClass("cartClosed");
        $("body").addClass("menuOpen");
        $("body").removeClass("cartOpen");
        $('#menuOverlay').fadeIn("fast");
    } else {
        $("#wrapper").addClass("menuClosed");
        $("body").removeClass("menuOpen");
        $('#menuOverlay').fadeOut("fast");
    }
    scrollIntoView(myactiveItem,false);
}

function toggleBackOfficeSidebar(show = !openSideMenu) {
    openSideMenu = show;
    DataStore.notifyAngularJs();
}

function initSidebarOpen() {
    setTimeout(_ => isSidebarOpen = $('body').hasClass('menuOpen'));
    $('#closeMenu').on('click',e => toggleSidebar(false));
    // $rootScope.$on('$stateChangeSuccess', function(ev, toState, toParams, fromState, fromParams) {
    EventBus.$on(EVENTS.route.after,(to: Route, from: Route) => {
        if ($(document).width() >= 1024 && justCameToState({from,to},'carte')) {
            toggleSidebar(true);
        }
        if (to.name == 'admin-login' || to.name == 'admin-signup') {
            toggleSidebar(false);
        }
    });
}

function justCameToState(transition: {from: Route, to: Route }, state: string) {
    return !_.startsWith(transition.from.name, state) && _.startsWith(transition.to.name, state);
}